// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2ebda057","977":"06cc4b1b"}[chunkId] + ".chunk.js";
};